import easybib from '@src/styled/theme'
import styled from 'styled-components'

export const List = styled.ul`
  padding-left: 24px;
  padding-right: 24px;

  & li:first-child {
    border-top: 0;
  }

  & li:last-child {
    border-bottom: 0;
  }

  & strong {
    font-weight: bold;
  }
`

export const ListItem = styled.li`
  border-color: ${easybib.colors.greyXlight};
  padding: 10px;
  list-style-type: none;
  border-width: 0.5px 0 0.5px 0;
  border-style: solid;
  font-weight: normal;
  font-size: 18px;
`



// WEBPACK FOOTER //
// ./src/components/base/List/index.tsx